import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Eye, EyeOff, AlertCircle } from 'lucide-react';
type LoginFormProps = {
  userType: 'customer' | 'vendor';
  onSubmit: (data: LoginFormData) => void;
};
export type LoginFormData = {
  email: string;
  password: string;
  rememberMe?: boolean;
};
export function LoginForm({
  userType,
  onSubmit
}: LoginFormProps) {
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: {
      errors,
      isSubmitting
    }
  } = useForm<LoginFormData>();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return <form onSubmit={handleSubmit(onSubmit)} className="space-y-6" data-id="element-57">
      <div data-id="element-58">
        <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-59">
          Email address
        </label>
        <div className="mt-1 relative" data-id="element-60">
          <input id="email" type="email" autoComplete="email" className={`block w-full px-4 py-3 rounded-md border ${errors.email ? 'border-red-300' : 'border-gray-300'} focus:outline-none focus:ring-primary focus:border-primary text-gray-900`} {...register('email', {
          required: 'Email is required',
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: 'Invalid email address'
          }
        })} placeholder="Enter your email" data-id="element-61" />
          {errors.email && <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-62">
              <AlertCircle className="h-5 w-5 text-red-500" data-id="element-63" />
            </div>}
        </div>
        {errors.email && <p className="mt-1 text-sm text-red-600" data-id="element-64">{errors.email.message}</p>}
      </div>
      <div data-id="element-65">
        <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-66">
          Password
        </label>
        <div className="mt-1 relative" data-id="element-67">
          <input id="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" className={`block w-full px-4 py-3 rounded-md border ${errors.password ? 'border-red-300' : 'border-gray-300'} focus:outline-none focus:ring-primary focus:border-primary pr-10 text-gray-900`} {...register('password', {
          required: 'Password is required',
          minLength: {
            value: 8,
            message: 'Password must be at least 8 characters'
          }
        })} placeholder="Enter your password" data-id="element-68" />
          <button type="button" className="absolute inset-y-0 right-0 flex items-center pr-3" onClick={togglePasswordVisibility} data-id="element-69">
            {showPassword ? <EyeOff className="h-5 w-5 text-gray-400" data-id="element-70" /> : <Eye className="h-5 w-5 text-gray-400" data-id="element-71" />}
          </button>
        </div>
        {errors.password && <p className="mt-1 text-sm text-red-600" data-id="element-72">{errors.password.message}</p>}
      </div>
      <div className="flex items-center justify-between" data-id="element-73">
        <div className="flex items-center" data-id="element-74">
          <input id="remember-me" type="checkbox" className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded" {...register('rememberMe')} data-id="element-75" />
          <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700" data-id="element-76">
            Remember me
          </label>
        </div>
        <div className="text-sm" data-id="element-77">
          <a href="#" className="font-medium text-primary hover:text-primary/80" data-id="element-78">
            Forgot your password?
          </a>
        </div>
      </div>
      <div data-id="element-79">
        <button type="submit" disabled={isSubmitting} className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-70" data-id="element-80">
          {isSubmitting ? 'Signing in...' : `Sign in as ${userType === 'customer' ? 'Customer' : 'Vendor'}`}
        </button>
      </div>
    </form>;
}